import { createRoot } from "react-dom/client";
import "@shared/topic-taxonomy-extensions";
import App from "./App";
import "./index.css";
import { initKakao } from "./lib/firebase";
import { initErrorTracking } from "./lib/error-tracking";

// Initialize Kakao SDK with retry mechanism
function initKakaoSDK() {
  const MAX_RETRIES = 10;
  let retries = 0;

  const tryInit = () => {
    if (typeof window !== 'undefined' && window.Kakao) {
      // Use centralized initKakao from firebase.ts
      initKakao();

      // Log available modules for debugging
      if (window.Kakao?.isInitialized()) {
        console.log('Kakao modules available:', {
          Auth: !!(window.Kakao as any).Auth,
          API: !!(window.Kakao as any).API,
          Link: !!(window.Kakao as any).Link,
        });
      }
    } else if (retries < MAX_RETRIES) {
      retries++;
      setTimeout(tryInit, 100);
    } else {
      console.error('❌ Kakao SDK failed to load after', MAX_RETRIES, 'retries');
    }
  };

  tryInit();
}

initKakaoSDK();

// Initialize error tracking
initErrorTracking();

// Mount React app
const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
} else {
  console.error('Root element not found');
}
